import { openai, SYSTEM_PROMPT } from './config';
import { ChatCompletionMessageParam } from 'openai/resources/chat';

export const generateResponse = async (
  userMessage: string,
  conversationHistory: ChatCompletionMessageParam[] = []
): Promise<string> => {
  try {
    const messages: ChatCompletionMessageParam[] = [
      { role: 'system', content: SYSTEM_PROMPT },
      ...conversationHistory,
      { role: 'user', content: userMessage }
    ];

    const response = await openai.chat.completions.create({
      model: 'gpt-3.5-turbo',
      messages,
      temperature: 0.7,
      max_tokens: 500,
      presence_penalty: 0.6,
      frequency_penalty: 0.5
    });

    return response.choices[0]?.message?.content || 'Désolé, je ne peux pas répondre pour le moment.';
  } catch (error) {
    console.error('OpenAI API error:', error);
    return 'Je rencontre des difficultés techniques. Veuillez réessayer ou contacter le support.';
  }
};

export const isApiAvailable = async (): Promise<boolean> => {
  try {
    await openai.chat.completions.create({
      model: 'gpt-3.5-turbo',
      messages: [{ role: 'user', content: 'test' }],
      max_tokens: 5
    });
    return true;
  } catch {
    return false;
  }
};